export default __webpack_public_path__ + "static/dealer3-f6cacf8cf2c3d6d8d4c641feca00c7c4.svg";